import Vue from 'vue'
import Vuex from 'vuex'
import students from './modules/students'
import banners from './modules/banners'
import dynamic from './modules/dynamic'
import classes from './modules/classes'
import teachers from './modules/teachers'
import curche from './modules/curche'
import my from './modules/my'
import homework from './modules/homework'
import events from './modules/events'
import information from './modules/information'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    students,
    banners,
    dynamic,
    classes,
    teachers,
    curche,
    my,
    homework,
    events,
    information
  },
  strict: debug
})




// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/store.js